import { component } from 'picoapp'

export default component((node,ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const gender = localStorage.getItem('spreeglee_gender') || 'unisex'

    
    /*******************************************************************************************************************************************/
    /* Init
    /*******************************************************************************************************************************************/
    updateGender(gender)


    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    ctx.on('gender:set', ({ gender }) => updateGender(gender))


    /*******************************************************************************************************************************************/
    /* Functions
    /*******************************************************************************************************************************************/
    function updateGender(gender) {
        node.classList.remove('gender--men', 'gender--women', 'gender--unisex')
        node.classList.add(`gender--${gender}`)
    }
})